import { render, staticRenderFns } from "./ShiftTransfer.vue?vue&type=template&id=002020e1&scoped=true&"
import script from "./ShiftTransfer.vue?vue&type=script&lang=js&"
export * from "./ShiftTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ShiftTransfer.vue?vue&type=style&index=0&id=002020e1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002020e1",
  null
  
)

export default component.exports